export default "<div class=\"dashboard\">\n    <app-counts></app-counts>\n    <app-customerlist></app-customerlist>\n</div>\n"